<app-header class="full-width"></app-header>
<main id="content" class="js-content" role="main">
  <div class="grid-row">
    <div [class]="shouldShowMore ? 'column-two-thirds' : 'column-full'">
      <div class="back-link-wrapper">
        <a routerLink="/check-start" class="back-link aa-link-size">Back</a>
      </div>
      <header class="page-header">
        <h1 class="aa-title-size" tabindex="0">Practice questions</h1>
      </header>

      <div class="grid-row">
        <div class="column-two-thirds">
          <p class="lede aa-copy-size" tabindex="0">There will be 3 practice questions.</p>
          <br />
          <button class="button button-start aa-button-size aa-contrast-button" role="button" id="start-now-button" (click)="onClick()">
            Start now
            <app-svg-arrow aria-hidden="true"></app-svg-arrow>
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="shouldShowMore" class="column-one-third more-links aa-copy-size">
        <strong class='aa-contrast-border' speak="true" tabindex="0">More</strong>
        <ul>
            <li><a routerLink="/access-settings">Edit your settings</a></li>
        </ul>
    </div>
  </div>
</main>
